module.exports = __webpack_public_path__ + "img/wal-main.412fe785.png";